import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Cancellation from './pages/Cancellation';
import ThankYou from './pages/ThankYou';
import SmoothScroll from './components/SmoothScroll';
import Hero from './components/Hero';
import LogoCloud from './components/LogoCloud';
import Services from './components/Services';
import Features from './components/Features';
import Stats from './components/Stats';
import HowItWorks from './components/HowItWorks';
import CaseStudies from './components/CaseStudies';
import Reviews from './components/Reviews';
import Testimonial from './components/Testimonial';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';
import ScrollProgress from './components/ScrollProgress';

function Home() {
  useEffect(() => {
    document.documentElement.classList.add('dark');
    return () => {
      document.documentElement.classList.remove('dark');
    };
  }, []);

  return (
    <main className="bg-background text-foreground font-sans">
      <SmoothScroll />
      <Hero />
      <LogoCloud />
      <Services />
      <Features />
      <Stats />
      <HowItWorks />
      <CaseStudies />
      <Reviews />
      <Testimonial />
      <Pricing />
      <FAQ />
      <CTA />
      <Footer />
    </main>
  );
}

function App() {
  return (
    <Router>
      <ScrollProgress />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/cancellation" element={<Cancellation />} />
        <Route path="/thanks" element={<ThankYou />} />
      </Routes>
    </Router>
  );
}

export default App;
